/** Central profile copy — single source for hire-facing messaging */
export const profile = {
  name: "Uche Kingsley Ogbonna",
  title: "Backend & Full-Stack Engineer",
  tagline:
    "I design and ship production APIs, real-time systems, and data layers that scale.",
  experienceYears: "4+",
  backendYears: "3+",
  cvUrl:
    "https://drive.google.com/file/d/1orcriBpowPCDiXXOd6PNazVEmook2Yv-/view?usp=sharing",
  email: "ucheogbonnak@gmail.com",
  location: "Nigeria",
  company: "Gruve Tickets",
};

export const backendHighlights = [
  {
    id: "apis",
    icon: "fa-solid fa-server",
    title: "REST & real-time APIs",
    detail: "Express, NestJS, Socket.IO, auth, validation, and clean service layers",
  },
  {
    id: "data",
    icon: "fa-solid fa-database",
    title: "Data & persistence",
    detail: "PostgreSQL, Prisma, MongoDB, TypeORM — migrations, queries, and integrity",
  },
  {
    id: "cloud",
    icon: "fa-solid fa-cloud",
    title: "Cloud & integrations",
    detail: "AWS S3, Stripe payments, webhooks, and third-party service wiring",
  },
  {
    id: "delivery",
    icon: "fa-solid fa-rocket",
    title: "Production delivery",
    detail: "Live products at gruve.events & giglink.africa — from schema to deploy",
  },
];
